export default ({ request }) => ({
  customerSendSampleListApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/list',
      method: 'POST',
      data,
    })
  },
  customerSendSampleDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/detail',
      method: 'POST',
      data,
    })
  },
  customerSendSampleSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/save',
      method: 'POST',
      data,
    })
  },
  customerSendSampleDelApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/del',
      method: 'POST',
      data,
    })
  },
  customerSendSampleCheckCustApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/check/cust',
      method: 'POST',
      data,
    })
  },
  customerSendSampleShipmentConfirmApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/shipmentConfirm',
      method: 'POST',
      data,
    })
  },
  customerSendSampleReceiveConfirmApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/receiveConfirm',
      method: 'POST',
      data,
    })
  },
  customerSendSampleDetailListApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/detail/list',
      method: 'post',
      data,
    })
  },
  customerSendSampleDetailSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/detail/save',
      method: 'post',
      data,
    })
  },
  customerSendSampleDetailSaveBatchApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/detail/save/batch',
      method: 'post',
      data,
    })
  },
  customerSendSampleDetailDelApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/detail/del',
      method: 'post',
      data,
    })
  },
  customerSendSampleLogListApi(data) {
    return request({
      url: '/digitalCenter/customer/send/sample/log/list',
      method: 'post',
      data,
    })
  },
})
